import { c as _c } from "react-compiler-runtime";
import { useCallback, useEffect, useRef } from 'react';
import usePageIsVisible from './useIsPageVisible';
import { getAssetKeyFromAsset } from 'collaboration-sidebar/utils/multipleAssets';
import useIsWindowActive from './useIsWindowActive';
import useHasCommentingFeature from './useHasCommentingFeature';
import * as commentingApi from '../api/CommentingV3';
export const POLL_INTERVAL_SIDEBAR_OPEN = 5000;
export const POLL_INTERVAL_SIDEBAR_CLOSED = 20000;
export default function usePollForCommentsChanges(t0) {
  "use memo";

  const $ = _c(15);
  const {
    objectId,
    objectType,
    onUpdateCollaborationSidebarState,
    hasSidebarPermission,
    assetsLastUpdated,
    isOpen,
    skip
  } = t0;
  const pageIsVisible = usePageIsVisible();
  const isWindowActive = useIsWindowActive();
  const hasCommentingFeature = useHasCommentingFeature();
  const pageIsVisibleAndActive = pageIsVisible && isWindowActive;
  const interval = useRef(undefined);
  const assetsLastUpdatedRef = useRef(assetsLastUpdated);
  let t1;
  if ($[0] !== assetsLastUpdated) {
    t1 = () => {
      assetsLastUpdatedRef.current = assetsLastUpdated;
    };
    $[0] = assetsLastUpdated;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useEffect(t1);
  let t2;
  if ($[2] !== objectType || $[3] !== onUpdateCollaborationSidebarState) {
    t2 = objectIdArg => {
      if (!objectType) {
        return;
      }
      commentingApi.fetchAssetLastUpdatedAt({
        objectId: objectIdArg,
        objectType
      }).then(t3 => {
        const {
          updatedAt
        } = t3;
        const assetKey = getAssetKeyFromAsset({
          objectId: objectIdArg,
          objectType
        });
        if (updatedAt !== assetsLastUpdatedRef.current[assetKey]) {
          onUpdateCollaborationSidebarState({
            assetsLastUpdated: Object.assign({}, assetsLastUpdatedRef.current, {
              [assetKey]: updatedAt
            })
          });
        }
      }).catch(_temp);
    };
    $[2] = objectType;
    $[3] = onUpdateCollaborationSidebarState;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const fetchLastUpdated = t2;
  let t3;
  let t4;
  if ($[5] !== fetchLastUpdated || $[6] !== hasCommentingFeature || $[7] !== hasSidebarPermission || $[8] !== isOpen || $[9] !== objectId || $[10] !== objectType || $[11] !== pageIsVisibleAndActive || $[12] !== skip) {
    t3 = () => {
      if (!objectId || skip) {
        return _temp2;
      }
      if (objectId && objectType && hasSidebarPermission && hasCommentingFeature && pageIsVisibleAndActive) {
        fetchLastUpdated(objectId);
        interval.current = setInterval(() => fetchLastUpdated(objectId), isOpen ? POLL_INTERVAL_SIDEBAR_OPEN : POLL_INTERVAL_SIDEBAR_CLOSED);
      }
      return () => {
        clearInterval(interval.current);
      };
    };
    t4 = [objectType, objectId, pageIsVisibleAndActive, hasSidebarPermission, isOpen, fetchLastUpdated, hasCommentingFeature, skip];
    $[5] = fetchLastUpdated;
    $[6] = hasCommentingFeature;
    $[7] = hasSidebarPermission;
    $[8] = isOpen;
    $[9] = objectId;
    $[10] = objectType;
    $[11] = pageIsVisibleAndActive;
    $[12] = skip;
    $[13] = t3;
    $[14] = t4;
  } else {
    t3 = $[13];
    t4 = $[14];
  }
  useEffect(t3, t4);
}
function _temp2() {}
function _temp() {}